import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";
import LabelArt from "@/components/LabelArt";

const ProductCard = ({ product, index = 0 }) => {
  const { add, openCart } = useCart();

  const quickAdd = (e) => {
    e.preventDefault();
    add(product.slug, 1);
    toast.success(`${product.name} added to your bag`);
    openCart();
  };

  return (
    <motion.div
      data-testid={`product-card-${product.slug}`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay: (index % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
      className="group"
    >
      <Link to={`/product/${product.slug}`} data-testid={`product-link-${product.slug}`} className="block">
        <div className="relative aspect-[4/5] overflow-hidden border border-line bg-white">
          {product.image ? (
            <img src={product.image} alt={`${product.name} soy wax candle`} className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.06]" />
          ) : (
            <LabelArt name={product.name} size={product.size} />
          )}
          <div className="pointer-events-none absolute inset-0 spotlight opacity-0 transition-opacity duration-700 group-hover:opacity-100" />
          <button
            data-testid={`quick-add-${product.slug}`}
            onClick={quickAdd}
            className="absolute bottom-0 left-0 right-0 translate-y-full bg-ink py-3.5 text-[10px] font-medium uppercase tracking-[0.28em] text-ivory transition-transform duration-500 ease-out hover:bg-coal group-hover:translate-y-0"
          >
            Quick Add
          </button>
        </div>
        <div className="pt-5">
          <div className="flex items-baseline justify-between gap-3">
            <h3 className="font-serif text-xl font-light tracking-tight">{product.name}</h3>
            <span className="text-sm font-medium">${product.price.toFixed(2)}</span>
          </div>
          <p className="mt-1 text-xs text-stone2">{product.notes.top} · {product.notes.heart.split(",")[0]}</p>
          <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.22em] text-stone2">Soy Wax · {product.size}</p>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
